import React, { useState, useContext } from 'react';
import styled, { keyframes } from 'styled-components';

import Icon from './Icon';

import ThemeIcons from '../../theme/Icons';
import ThemeContext from '../../theme/ThemeContext';

export const RotateKeyframeAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: ${(props) => (props.$styles && props.$styles.borderRadius ? `${props.$styles.borderRadius}` : `${props.theme.borderRadius}px`)};
  border: ${(props) => (props.$styles && props.$styles.border ? `${props.$styles.border}` : `1px solid ${props.theme.borderColor}`)};
  width: ${(props) => props.$styles && props.$styles.width && `${props.$styles.width}`};
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(props) => (props.$styles && props.$styles.padding ? `${props.$styles.padding}` : '8px')};
  border-bottom: 1px solid transparent;
  transition-property: border-bottom;
  transition-duration: 300ms;

  &:hover {
    cursor: pointer;
  }

  svg {
    display: inline-block;
    transform: rotate(90deg);
    transition-duration: 0.3s;
    font-size: 12px;
  }

  &.isOpen {
    border-bottom: ${(props) => (props.$styles && props.$styles.borderBottom ? `${props.$styles.borderBottom}` : `1px solid ${props.theme.borderColor};`)};
    svg {
      display: inline-block;
      transform: rotate(0deg);
      transition-duration: 0.3s;
    }
`;

const StyledHeaderTitle = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 14px;
  flex: 1;
  color: ${(props) => props.theme.fontColorPrimary};
`;

const StyledContent = styled.div`
  display: flex;
  height: 0px; 
  transition: all 0.3s ease-in-out;
  overflow: ${(props) => (props.$styles && props.$styles.overflow ? `${props.$styles.overflow}` : 'auto')};

  &.isOpen {
    height: ${(props) => (props.$height && props.$enforceHeight ? `${props.$height}px` : '100%')};
  }

`;

export default function Accordion({
  isOpen = false,
  title,
  height,
  enforceHeight = false,
  children,
  extraStyles,
  onClick
}) {

  const theme = useContext(ThemeContext);

  const [open, setOpen] = useState(isOpen);
  const handleToggle = () => {
    setOpen(!open);
    if (onClick) onClick(!open);
  };

  return (
    <StyledWrapper $styles={extraStyles} theme={theme}>
      <StyledHeader theme={theme} $styles={extraStyles} onClick={handleToggle} className={`accordion__header ${open ? 'isOpen' : ''}`}>
        <StyledHeaderTitle theme={theme}>{title}</StyledHeaderTitle>
        <Icon icon={ThemeIcons.misc.chevronDown} color={theme.fontColorSecondary} hoverColor={theme.primaryColor} />
      </StyledHeader>
      <StyledContent $styles={extraStyles} $enforceHeight={enforceHeight} $height={height} className={`accordion__content ${open ? 'isOpen' : ''}`}>
        {children}
      </StyledContent>
    </StyledWrapper>
  );
}
